import React, { useState } from 'react'
import { BrowserRouter, Routes, Route, Router } from 'react-router-dom'
import GoogleAnalytics from './components/Analytics';
import Home from './components/Home';
import Navbarmenu from './components/Navbarmenu';
import AcercaDe from './components/AcercaDe';
import Footer from './components/Footer';
import FormPP2023 from './components/FormPP2023';
import RegistrarUsuarioProyectos from './components/RegistrarUsuarioProyectos';
import LoginUsuariosProyectos from './components/LoginUsuariosProyectos';
import LoginUsuariosAdmin from './components/LoginUsuariosAdmin';
import PanelUsuarioProyectos from './components/PanelUsuarioProyectos';
import PanelAdmin from './components/PanelAdmin';
import PanelVotante from './components/PanelVotante';
import DetalleProyectos from './components/DetalleProyectos';
import Error from './components/Error';
import ProyectosHome from './components/ProyectosHome';
import PropuestasDetalle from './components/PropuestasDetalle';
import HeroVotar from './components/VotarHero';
import LoginForm from './components/LoginAsistentesForm';
import SocialMetaTags from './components/SocialMetaTags';
import SystemOptionsLoader from './components/OpcionesSistema';
import WhatsAppButton from './components/Whatsapp';
import FloatingContactButton from './components/ButtonFlotante';
import VotantesPendientes from './components/VotosPendientes';
import PanelVotanteLink from './components/PanelVotanteLink';
import VotingStatusCheck from './components/VotingStatusCheck';
import Estadisticas from './components/Estadisticas'

const initialUser = {
  error: false,
  login:false,
  id_user:null,
  name_user: '',
  token_user: '',
  errorMsg: ''
}

const initialUserAdmin = {
  error: false,
  login:false,
  id_user:null,
  name_user: '',
  token_user: '',
  errorMsg: ''
}

const initialUserVotante = {
  error: false,
  login:false,
  id_user:null,
  name_user: '',
  token_user: '',
  errorMsg: ''
}

function App() {
  const [user, setUser]= useState(initialUser);
  const [userAdmin, setUserAdmin]= useState(initialUserAdmin);
  const [userVotante, setUserVotante]= useState(initialUserVotante)
  const logout = () => {
    setUser(initialUser)
  }   
  return (

    <BrowserRouter basename="/pp">
      
      <Navbarmenu user={user} setUser={setUser} userAdmin={userAdmin} setUserAdmin={setUserAdmin} />    
      <GoogleAnalytics measurementId="G-SVX2NCPV9N" />
      <SocialMetaTags /> 
      
      <SystemOptionsLoader />     
      <VotingStatusCheck/>
      <Routes>
        <Route exact path="/" element={<Home user={user} />} />
        <Route path="/acercade" element={<AcercaDe user={user}  />} />
        <Route path="/cargarproyecto" element={<FormPP2023 user={user} setUser={setUser}  />} />
        <Route path="/registrarusuario" element={<RegistrarUsuarioProyectos user={user} setUser={setUser} />} />
        <Route path="/iniciarsesionproyectos" element={<LoginUsuariosProyectos user={user} setUser={setUser} />} />
        <Route path="/paneladmin" element={<PanelAdmin userAdmin={userAdmin} setUserAdmin={setUserAdmin}  />} />
        <Route path="/estadisticas" element={<Estadisticas   />} />
        <Route path="/propuestas" element={<ProyectosHome userVotante={userVotante} setUserVotante={setUserVotante} userAdmin={userAdmin} setUserAdmin={setUserAdmin}  />} />
        <Route path="/propuestas/:id" element={<PropuestasDetalle userVotante={userVotante} setUserVotante={setUserVotante} userAdmin={userAdmin} setUserAdmin={setUserAdmin}  />} />
        <Route path="/votarpropuestas" element={<PanelVotante userVotante={userVotante} setUserVotante={setUserVotante} userAdmin={userAdmin} setUserAdmin={setUserAdmin}  />} />
        <Route path="/panelvotantelink" element={<PanelVotanteLink   />} />
        <Route path="/votar" element={<HeroVotar  />} />
        <Route path="/votopresencial" element={<LoginForm />} />
        <Route path="/votospendientes" element={<VotantesPendientes />} />
        <Route path="/iniciarsesionadmin" element={<LoginUsuariosAdmin userAdmin={userAdmin} setUserAdmin={setUserAdmin}  />} />
        <Route path="/panelusuarioproyectos" element={<PanelUsuarioProyectos user={user} setUser={setUser}  />} />
        <Route path="/detalleproyectos/:id" element={<DetalleProyectos userAdmin={userAdmin} user={user} />} />
        <Route path="*" element={<Error />} />
      </Routes>

      <WhatsAppButton/>
      <FloatingContactButton />
  
      <Footer />
    </BrowserRouter>    

  );
}

export default App;